import React from "react";
import FormRegistro from "./FormRegistro";
import { Box } from "@mui/material";

function formularioDeRegistro() {
  return <FormRegistro />;
}
function LoginEmail() {
  return (
    <div className="mt-5 text-center formcontainerr">
      <div id="brandsLogo">
        <Box
          component="img"
          src={
            "https://firebasestorage.googleapis.com/v0/b/bicci-7ed2f.appspot.com/o/webfrontend%2Fweb-bicciexpress%2Ficonografiabicci%2Ficono%20(24).svg?alt=media&token=ef6abc30-ba25-4422-bd45-5821ae5dc2cf"
          }
          alt=""
          sx={{
            height: "auto",
            maxWidth: "100px",
            backgroundColor: "#fff",
            borderRadius: "100%",
          }}
        />
      </div>
      <h2>REGISTRARSE</h2>
      {formularioDeRegistro()}
    </div>
  );
}

export default LoginEmail;
